export const getUniversityCategory = (tuitionFees) => {
  if (typeof tuitionFees === "string") {
    tuitionFees = tuitionFees.replace(/[^\d.-]/g, ""); // Remove non-numeric characters
  }

  // Convert tuitionFees to a number
  const fee = parseFloat(tuitionFees);

  if (isNaN(fee)) {
    return "Unknown"; // Return 'Unknown' if tuitionFees is not a valid number
  }

  if (fee > 50000) {
    return "Premium";
  } else if (fee > 25000) {
    return "Mid-Range";
  } else {
    return "Affordable";
  }
};
